import { create } from "zustand";

// 0016 Slice 3 — global store for the impersonation banner. The
// apiClient response middleware (in api/client.ts) populates this on
// every response that carries X-Impersonating-User-ID; the
// ImpersonationBanner component reads it and renders the sticky
// red bar.
//
// Why a store and not a query: the signal arrives on EVERY response
// (the auth middleware stamps the headers any time the impersonation
// cookie is honored), so reading it from a single fetch wouldn't
// suffice. A store lets any response propagate the signal globally.

interface ImpersonationState {
  /** true if the most recent API response stamped X-Impersonating-User-ID. */
  active: boolean;
  /** Target user ID the admin is impersonating. */
  targetUID: string | null;
  /** Admin user ID doing the impersonation. */
  adminUID: string | null;
  /** Setter used by the apiClient response middleware. */
  set: (active: boolean, targetUID: string | null, adminUID: string | null) => void;
  /** Clears the store after Stop-impersonating. */
  clear: () => void;
}

export const useImpersonationStore = create<ImpersonationState>((set) => ({
  active: false,
  targetUID: null,
  adminUID: null,
  set: (active, targetUID, adminUID) => set({ active, targetUID, adminUID }),
  clear: () => set({ active: false, targetUID: null, adminUID: null }),
}));
